import clsx from "clsx"

import style from "./style.module.scss"

import type { FC, ReactNode } from "react"

type Props = {
  variant?: "primary" | "white" | "black" | "grey"
  children?: ReactNode
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  loading?: boolean
  leftIcon?: ReactNode
  className?: string
  type?: "button" | "submit" | "reset"
  id?: string
  size?: "medium" | "small"
}

const Button: FC<Props> = ({
  children,
  onClick,
  type,
  disabled,
  loading,
  leftIcon,
  className,
  id,
  variant = "primary",
  size = "medium"
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (loading || disabled) {
      return
    }

    onClick?.(e)
  }

  return (
    <button
      className={clsx(style.button, className, {
        [style.white]: variant === "white",
        [style.black]: variant === "black",
        [style.grey]: variant === "grey",
        [style.small]: size === "small",
        [style.loading]: loading,
        [style.disabled]: disabled
      })}
      style={
        disabled
          ? {
              pointerEvents: "none",
              opacity: "0.7"
            }
          : {}
      }
      onClick={handleClick}
      type={type}
      id={id}
    >
      <div className={style.content}>
        {leftIcon}
        {children}
      </div>

      {loading && <div className={style.loader} />}
    </button>
  )
}

export default Button
